import type { TFunction } from 'i18next';
import type { ReactNode } from 'react';

import {
  Box,
  Stack,
  StyleSheet,
  Typography,
  Barcode,
  IconBar,
} from '@woovi/pdf';

const styles = StyleSheet.create({
  heading: {
    marginTop: 25,
  },
  page: {
    padding: '32 20 52 20',
  },
  label: {
    fontSize: 10,
    textAlign: 'center',
  },
  labelSmall: {
    fontSize: 8,
    display: 'flex',
    flexWrap: 'wrap',
  },
  barCode: {
    marginTop: 10,
    maxWidth: 344,
  },
  leftColumn: {
    flexDirection: 'column',
    gap: '4px',
    padding: '4px 6px',
    width: 390,
  },
  rightColumn: {
    flexDirection: 'column',
    gap: '4px',
    borderLeft: '1px solid black',
    padding: '4px 6px',
    height: '100%',
  },
  rightColumnStacked: {
    flexDirection: 'column',
    gap: '4px',
    padding: '4px 6px',
  },
  valueSmall: {
    fontSize: '10px',
    width: 152,
  },
  value: {
    fontSize: '10px',
    textTransform: 'uppercase',
  },
});

const WrapText = ({ text }: { text?: string }): ReactNode => (
  <Box style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
    {text?.match(/\w+|\W+/g)?.map((seg, i) => (
      <Typography
        style={{
          fontSize: 8,
          paddingLeft: 3,
        }}
        key={i}
      >
        {seg}
      </Typography>
    ))}
  </Box>
);

type ChargePDFDocumentBoletoProps = {
  barcode: string;
  digitable: string;
  t: TFunction;
};

export const ChargePDFDocumentBoleto = ({
  barcode,
  digitable,
  t,
}: ChargePDFDocumentBoletoProps): ReactNode => {
  return (
    <Stack direction='row' style={{ justifyContent: 'space-between' }}>
      <Stack
        style={{
          marginBottom: 20,
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: 420,
          gap: 6,
        }}
      >
        <Stack
          direction='row'
          style={{ gap: 4, alignItems: 'center', marginTop: 12 }}
        >
          <IconBar size={12} />
          <Typography style={styles.label}>{t('Digitable line')}</Typography>
        </Stack>
        <WrapText text={digitable} />
        <Stack
          direction='column'
          style={{
            alignItems: 'flex-start',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Barcode barcode={barcode} />
        </Stack>
      </Stack>
    </Stack>
  );
};
